import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: '24px',
          fontFamily: 'monospace',
          background: 'var(--bg)',
          minHeight: '100vh',
          boxSizing: 'border-box',
        }}>
          <h2 style={{ color: 'var(--danger)', marginBottom: 8 }}>Crash — copia questo e mandalo allo sviluppatore</h2>
          <pre style={{
            background: 'var(--ctp-base, #1e1e2e)',
            color: 'var(--text-primary)',
            padding: '16px',
            borderRadius: '8px',
            overflowX: 'auto',
            fontSize: '12px',
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
          }}>
            {String(this.state.error?.message || this.state.error)}
            {'\n\n'}
            {this.state.error?.stack}
          </pre>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              marginTop: 16,
              padding: '10px 20px',
              background: 'var(--danger)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
